import * as Sentry from '@sentry/vue';
class Logger {
    constructor() {
    }
    error(error, context) {
        try {
            console.error(error, context);
            Sentry.withScope(scope => {
                if (context) {
                    scope.setContext("custom", context);
                }
                Sentry.captureException(error);
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    message(message, context) {
        try {
            console.log(message, context);
            Sentry.withScope(scope => {
                if (context) {
                    scope.setContext("custom", context);
                }
                Sentry.captureMessage(message);
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    setContext(name, context) {
        try {
            Sentry.setContext(name, context);
        }
        catch (e) {
            console.error('Failed to set Sentry context:', e);
            // Report to Sentry directly to avoid recursion
            try {
                Sentry.captureException(e);
            }
            catch {
                // Silently fail if Sentry itself is broken
            }
        }
    }
    clearContext(name) {
        try {
            Sentry.setContext(name, null);
        }
        catch (e) {
            console.error('Failed to clear Sentry context:', e);
            // Report to Sentry directly to avoid recursion
            try {
                Sentry.captureException(e);
            }
            catch {
                // Silently fail if Sentry itself is broken
            }
        }
    }
}
export default new Logger();
